import React from "react";

const SquarePlus = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
        <path id="square-plus-solid" d="M7.714,32A7.721,7.721,0,0,0,0,39.714V78.286A7.721,7.721,0,0,0,7.714,86H46.286A7.721,7.721,0,0,0,54,78.286V39.714A7.721,7.721,0,0,0,46.286,32ZM24.107,69.607V61.893H16.393a2.893,2.893,0,0,1,0-5.786h7.714V48.393a2.893,2.893,0,0,1,5.786,0v7.714h7.714a2.893,2.893,0,0,1,0,5.786H29.893v7.714a2.893,2.893,0,0,1-5.786,0Z" transform="translate(0 -32)" fill="#eedbc4"/>
    </svg>
}

export default SquarePlus;
